import * as React from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';
import { Card, CardContent, CardMedia, Container } from '@mui/material';
import Carousel from 'react-material-ui-carousel';

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    minWidth: "60%",
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
};

export default function ViewNews({ news, images }) {
    const [open, setOpen] = React.useState(false);
    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);
    return (
        <div>
            {/* <Button onClick={handleOpen}>View Profile</Button> */}
            <Button onClick={handleOpen} style={{ width: 300 }}>
                <img src={images[0]} width={300} />
            </Button>

            <Modal
                open={open}
                onClose={handleClose}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Card sx={style}>
                    <Carousel>
                        {images.map((item, i) =>
                            <CardMedia
                                component="img"

                                image={item} />
                        )
                        }
                    </Carousel>
                </Card>

            </Modal>
        </div >
    );
}